export const REPORT_CALENDAR_CREATE_REPORT_DRAWER = {
	title: 'Create new report',
	width: 480,
	submitLabel: 'Create',
}

export const REPORT_CALENDAR_CREATE_REPORT_BUSINESS_OPTIONS = [
	{ value: 'company-1', label: 'Company 1' },
	{ value: 'company-2', label: 'Company 2' },
]

export const REPORT_CALENDAR_CREATE_REPORT_TYPE_OPTIONS = [
	{ value: 'vat', label: 'VAT' },
	{ value: 'sales-list', label: 'Sales list' },
	{ value: 'oss', label: 'OSS' },
	{ value: 'ioss', label: 'IOSS' },
	{ value: 'sales-tax', label: 'Sales tax' },
]

export const getInitialCreateReportFormState = (defaultDate = null) => ({
	business: '',
	date: defaultDate,
	reportType: '',
})
